
import { Shield, CheckCircle, Eye } from "lucide-react";
import AnimatedCard from "@/components/AnimatedCard";
import { Card } from "@/components/ui/card";

const TrustSection = () => {
  return (
    <section className="py-20 bg-secondary/80">
      <div className="container mx-auto px-6">
        <AnimatedCard animation="fade-in" className="mb-10 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Built with <span className="text-primary">Trust</span> at the Core
          </h2>
        </AnimatedCard>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <AnimatedCard animation="slide-in-left">
            <div className="space-y-6">
              <p className="text-lg text-gray-300">
                We help firms adopt AI responsibly — without compromising security, compliance, or 
                ethical standards. Our guidance is grounded in privacy-by-design thinking, and every 
                recommendation we make puts legal responsibility first.
              </p>
            </div>
          </AnimatedCard>
          
          <AnimatedCard animation="slide-in-right" delay={200}>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <Card className="p-6 flex flex-col items-center text-center bg-card/50 backdrop-blur-sm border-white/10">
                <div className="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center mb-4">
                  <Shield className="h-8 w-8 text-primary" />
                </div>
                <h3 className="text-xl font-semibold mb-2">Security</h3>
              </Card>
              
              <Card className="p-6 flex flex-col items-center text-center bg-card/50 backdrop-blur-sm border-white/10">
                <div className="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center mb-4">
                  <CheckCircle className="h-8 w-8 text-primary" />
                </div>
                <h3 className="text-xl font-semibold mb-2">Compliance</h3>
              </Card>
              
              <Card className="p-6 flex flex-col items-center text-center bg-card/50 backdrop-blur-sm border-white/10">
                <div className="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center mb-4">
                  <Eye className="h-8 w-8 text-primary" />
                </div>
                <h3 className="text-xl font-semibold mb-2">Transparency</h3>
              </Card>
            </div>
          </AnimatedCard>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
